import {Stack} from '@chakra-ui/layout';
import {Text, Button} from '@chakra-ui/react';
import router from 'next/router';
import {FC, useEffect} from 'react';
import {ModalTypes, useModalContext} from '..';
import {useCancelTransferMutation} from '../../../graphql/generated';
import {useAppToast} from '../../../hooks/app-toast';
import {theme} from '../../../style/theme';

const ShareNavigation = (): JSX.Element => {
  const {onChange, setIsLoaded, signature, onClose} = useModalContext();

  return (
    <>
      <Stack
        direction="row"
        mt={{base: '30px', xl: '104px'}}
        spacing={10}
        maxW="90%"
      >
        <Button
          size="lg"
          colorScheme="aqua"
          px={{base: '20px', md: '80px'}}
          alignSelf="center"
          flex={1}
          onClick={() => {
            if (onChange) onChange('certificate');
            setIsLoaded(false);
          }}
          fontSize={{base: '12px', md: '16px'}}
        >
          View my certificate of ownership
        </Button>
        {!signature ? (
          <Button
            size="lg"
            colorScheme="copper"
            px={{base: '20px', md: '80px'}}
            alignSelf="center"
            flex={1}
            onClick={() => {
              router.push('/add-your-signature');
            }}
            fontSize={{base: '12px', md: '16px'}}
          >
            Add my signature
          </Button>
        ) : null}
      </Stack>
      <Text textStyle="body2" color="white" my={{base: 4, xl: 8}}>
        or
      </Text>
      <Text
        as="button"
        textStyle={{base: 'body2', md: 'body1'}}
        color="white"
        textDecor="underline"
        onClick={onClose}
      >
        Continue to Collection
      </Text>
    </>
  );
};

const CancelTransfer = () => {
  const {transactionId, onClose} = useModalContext();
  const toast = useAppToast();

  const [cancelTransferMutation, {data, loading, error}] =
    useCancelTransferMutation({
      variables: {
        transactionId: transactionId as string,
      },
    });

  useEffect(() => {
    if (!data) return;
    if (!error)
      toast.showInfoToast(
        'The gift code has been removed from your transaction history. You still own the pieces!',
        'Gift code deactivated',
      );
    onClose();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, error]);

  return (
    <Text textStyle="body3" color={theme.colors.white} mt={8}>
      Changed your mind and want to keep these pieces?{' '}
      <Text
        as="button"
        color={theme.colors.stampRed}
        fontWeight={600}
        textDecoration="underline"
        ml={{md: 2}}
        onClick={() => cancelTransferMutation()}
        disabled={loading}
      >
        {loading ? 'Deactivating gift code' : 'Deactivate this gift code'}
      </Text>
    </Text>
  );
};

const navigation: Record<ModalTypes, JSX.Element> = {
  certificate: <></>,
  redeem: <CancelTransfer />,
  share: <ShareNavigation />,
  deed: <></>,
  wallet: <></>,
};

export const Navigation: FC<{type: ModalTypes}> = ({type}) => {
  return <>{navigation[type]}</>;
};
